export interface IEnergyTip {
  title: string;
  type: number;
  subtitle: string;
  desc: string;
  color: string;
}

export const LISTA_AHORRO: IEnergyTip[] = [
  // --- AGUA FRÍA ---
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Cerrar grifos mientras te cepillas dientes ahorra hasta 12 litros diarios.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Ducharse en lugar de bañarse reduce consumo de agua más del 50%.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Lavando platos con grifo cerrado se ahorra hasta 30% de agua.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Lavar ropa solo con carga completa ahorra 15 litros por ciclo.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Reparar fugas de grifo evita desperdiciar más de 200 litros mensuales.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Instalar filtros reduce sedimentos y evita desperdicio innecesario de agua potable.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Evitar dejar grifo abierto mientras enjabonas manos ahorra litros diarios.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Monitorizar consumo detecta anomalías y previene pérdidas continuas de agua.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Lavar coche con cubo en lugar de manguera reduce consumo hasta 60%.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Reutilizar agua de lavar verduras para riego puede ahorrar cientos de litros.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Instalar aireadores en grifos reduce caudal sin afectar presión.',
    color: '#2C3E50',
  },
  {
    title: 'Ahorro de agua fría',
    type: 1,
    subtitle: '',
    desc: 'Electrodomésticos eficientes consumen menos agua y electricidad en cada ciclo.',
    color: '#2C3E50',
  },

  // --- POZO ---
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Revisar bombas regularmente mejora eficiencia y reduce consumo eléctrico innecesario.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Limpiar filtros evita bloqueos y sobreconsumo de energía.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Ajustar presión de bombeo según necesidades reales reduce pérdidas.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Evitar fugas en tuberías subterráneas ahorra litros y electricidad.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Programar extracción según demanda optimiza energía y agua consumida.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Mantener válvulas en buen estado evita desperdicio constante.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Usar filtros de sedimentos mejora calidad y eficiencia de bombeo.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Controlar niveles previene sobreexplotación y daño a la bomba.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Inspeccionar bombas antes de temporada alta evita fallos y pérdidas.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Evitar extraer agua innecesaria prolonga vida útil del pozo.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Documentar consumos ayuda a planificar mantenimiento preventivo eficiente.',
    color: '#748D92',
  },
  {
    title: 'Gestión de pozo',
    type: 1,
    subtitle: '',
    desc: 'Monitorear consumo permite detectar fugas ocultas rápidamente.',
    color: '#748D92',
  },

  // --- RIEGO ---
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Riega al amanecer o anochecer para minimizar evaporación hasta 40%.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Sistemas de goteo reducen consumo hasta 50% frente riego tradicional.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Ajustar temporizador según necesidades evita exceso de riego innecesario.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Evitar regar superficies pavimentadas reduce desperdicio notable de agua.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Mulching conserva humedad, reduciendo consumo diario hasta 30%.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    subtitle: '',
    desc: 'Revisar válvulas y mangueras evita fugas que desperdician litros.',
    color: 'green',
    type: 1,
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Programar riego según estación ahorra agua y energía asociada.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    subtitle: '',
    desc: 'Plantas autóctonas reducen hasta 70% consumo de agua.',
    color: 'green',
    type: 1,
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Reutilizar agua de lavado de verduras para riego ahorra litros diarios.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Ajustar presión evita exceso de caudal en zonas pequeñas.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Limpiar filtros de bombas mantiene eficiencia y evita sobreconsumo.',
    color: 'green',
  },
  {
    title: 'Riego eficiente',
    type: 1,
    subtitle: '',
    desc: 'Evitar riego cuando llueve o suelo húmedo previene desperdicio total.',
    color: 'green',
  },

  // --- AGUA CALIENTE ---
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Mantener temperatura adecuada evita gasto innecesario de energía hasta 15%.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Descongelar alimentos en nevera evita usar agua caliente adicional.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Lavavajillas eficiente consume menos agua que lavado manual prolongado.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Reparar fugas en grifos o calentadores evita derroche continuo.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Programar calentador solo cuando es necesario ahorra energía diaria.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Reducir tiempo de duchas con temporizador ahorra hasta 10 litros diarios.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Instalar grifos termostáticos optimiza consumo de agua caliente.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Aprovechar agua residual para limpieza reduce consumo doméstico.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Aislar tuberías de agua caliente evita pérdidas hasta 20%.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Mantener acumuladores revisados asegura funcionamiento seguro y eficiente.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Limpiar filtros de grifos y duchas mantiene rendimiento.',
    color: 'orange',
  },
  {
    title: 'Agua caliente',
    type: 2,
    subtitle: '',
    desc: 'Evitar abrir grifo innecesariamente mientras esperas agua caliente.',
    color: 'orange',
  },

  // --- CALORÍMETROS ---
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Revisar lecturas periódicas permite detectar consumos anómalos rápidamente.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Ajustar temperatura de radiadores según medición real optimiza energía.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Detectar anomalías previene gastos innecesarios y pérdidas energéticas.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Evitar sobrecalentar estancias reduce consumo hasta 7% mensual.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Mantener válvulas calibradas asegura mediciones precisas y ahorro efectivo.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Programar horarios de calefacción según ocupación ahorra energía diariamente.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Controlar fugas evita derroche de agua caliente.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Revisar sensores y conexiones garantiza eficiencia continua.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Optimizar distribución de calor según consumo histórico ahorra energía.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Evitar cambios bruscos de temperatura reduce gasto innecesario.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Limpiar radiadores y colectores mejora eficiencia térmica.',
    color: 'deepOrange',
  },
  {
    title: 'Control térmico',
    type: 2,
    subtitle: 'Calorímetros',
    desc: 'Documentar consumos facilita mantenimiento preventivo y ahorro sostenido.',
    color: 'deepOrange',
  },

  // --- CALEFACCIÓN ---
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Mantener termostato entre 19 y 21°C mejora eficiencia hasta 10%.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Sellar ventanas y puertas evita pérdidas de calor significativas.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Programar calefacción solo cuando estancias ocupadas reduce gasto diario.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Bajar persianas por la noche conserva temperatura interior.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Aprovechar luz solar calienta estancias sin coste energético.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Mantener radiadores despejados mejora circulación y eficiencia.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Ajustar termostato un grado menos reduce consumo hasta 7%.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Aislar techos y paredes disminuye demanda energética considerablemente.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Controlar fugas en retorno evita pérdidas de calor.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Revisar purgadores de aire mejora eficiencia de sistema.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Mantener cronotermostatos calibrados optimiza consumo.',
    color: 'red',
  },
  {
    title: 'Calefacción',
    type: 3,
    subtitle: '',
    desc: 'Limpiar radiadores asegura distribución uniforme del calor.',
    color: 'red',
  },

  // --- FANCOIL ---
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Mantener filtros limpios garantiza eficiencia y calidad de aire.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Programar encendido según ocupación ahorra energía.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Mantener salidas de aire despejadas distribuye mejor calor/frío.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Ajustar temperatura según estación optimiza confort y consumo.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Revisar fugas de agua evita desperdicio y daños.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Limpieza periódica de ventiladores y bobinas mantiene eficiencia.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Evitar cambios bruscos de temperatura reduce consumo innecesario.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Optimizar distribución evita calentar o enfriar zonas vacías.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Usar ventiladores techo mejora eficiencia en verano.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Ajustar caudal aire según demanda real.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Documentar mantenimiento asegura funcionamiento constante.',
    color: 'red',
  },
  {
    title: 'Climatización fancoil',
    type: 3,
    subtitle: '',
    desc: 'Revisar controladores electrónicos previene mal funcionamiento.',
    color: 'red',
  },

  // --- RETORNO ---
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Controlar retorno agua evita pérdidas térmicas hasta 15%.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Revisar válvulas periódicamente asegura correcto flujo.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Evitar bloqueos mejora eficiencia del sistema.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Ajustar caudal según demanda reduce consumo energético.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Limpiar tuberías de retorno mantiene rendimiento.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Monitorear temperatura retorno detecta anomalías.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Mantener purgadores aire en buen estado.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Evitar fugas mejora eficiencia general.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Documentar lecturas permite mantenimiento preventivo eficiente.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Programar mantenimiento según fabricante reduce fallos.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Ajustar presión circuito evita derroche.',
    color: 'pink',
  },
  {
    title: 'Sistema retorno',
    type: 3,
    subtitle: '',
    desc: 'Revisar acumuladores conectados al retorno optimiza energía.',
    color: 'pink',
  },

  // --- COMBUSTIBLES ---
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Revisar reguladores y válvulas antes de temporada reduce riesgos.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Mantener filtros limpios asegura combustión eficiente.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Detectar fugas de gas protege seguridad y ahorro.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Programar calefacción según ocupación reduce consumo.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Purga sistemas de combustible evita bloqueos y derroche.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Ajustar quemadores optimiza consumo hasta 12%.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Limpiar chimeneas y salidas gases mantiene eficiencia.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Realizar mantenimiento preventivo asegura rendimiento seguro.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Monitorear niveles de combustible planifica reposición eficiente.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Evitar sobrecalentar espacios desocupados reduce gasto innecesario.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Instalar detectores gas mejora seguridad y evita pérdidas.',
    color: 'brown',
  },
  {
    title: 'Combustibles',
    type: 3,
    subtitle: 'Gas / Gasoil / Propano',
    desc: 'Documentar consumos controla gasto y detecta anomalías.',
    color: 'brown',
  },

  // --- AIRE ACONDICIONADO ---
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Mantener filtros limpios mejora eficiencia hasta 15%.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Ajustar temperatura entre 24 y 26°C reduce consumo eléctrico.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Programar encendido según ocupación evita gasto innecesario.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Mantener salidas de aire despejadas distribuye correctamente frío.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Revisar fugas refrigerante aumenta eficiencia energética.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Evitar cambios bruscos de temperatura prolonga vida útil.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Optimizar distribución evita enfriar zonas vacías.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Apagar equipos cuando no se usan reduce consumo.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Usar cortinas persianas reduce ganancia solar hasta 10%.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Limpiar compresores y ventiladores asegura funcionamiento óptimo.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Ajustar humedad optimiza confort sin gastar energía extra.',
    color: 'blue',
  },
  {
    title: 'Aire Acondicionado',
    type: 4,
    subtitle: '',
    desc: 'Revisar aislamiento conductos minimiza pérdidas energéticas.',
    color: 'blue',
  },

  // --- FANCOIL FRIO ---
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Mantener filtros limpios garantiza eficiencia y calidad aire.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Programar encendido según ocupación ahorra energía.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Mantener salidas de aire despejadas distribuye mejor frío.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Ajustar temperatura según estación optimiza confort y consumo.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Revisar fugas de agua evita desperdicio y daños.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Limpieza periódica de ventiladores y bobinas mantiene eficiencia.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Evitar cambios bruscos temperatura reduce consumo innecesario.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Optimizar distribución evita enfriar zonas vacías.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Usar ventiladores techo mejora eficiencia.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Ajustar caudal aire según demanda real.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Documentar mantenimiento asegura funcionamiento constante.',
    color: 'lightBlue',
  },
  {
    title: 'Frío fancoil (refrigeración)',
    type: 5,
    subtitle: '',
    desc: 'Revisar controladores electrónicos previene mal funcionamiento.',
    color: 'lightBlue',
  },

  // --- ELECTRICIDAD ---
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Apagar dispositivos en standby reduce consumo hasta 10%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Usar bombillas LED de tono cálido mejora descanso y ahorra 80%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Desconectar cargadores sin uso evita consumo fantasma.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Aprovechar luz natural reduce uso electricidad hasta 15%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Usar regletas con interruptor facilita apagado múltiple.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Ajustar electrodomésticos grandes para consumo eficiente diario.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Secar ropa al aire reduce uso de secadora 100%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Programas eco lavadora, lavavajillas reducen consumo hasta 20%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Cocinar con tapa ahorra energía hasta 25% del consumo.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Planchar varias prendas juntas optimiza calor residual.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Mantener filtros electrodomésticos limpios mejora rendimiento hasta 15%.',
    color: 'yellow',
  },
  {
    title: 'Electricidad',
    type: 6,
    subtitle: 'Energía',
    desc: 'Monitorizar consumo eléctrico permite ajustar hábitos y reducir facturas.',
    color: 'yellow',
  },

  // --- OTROS / REPARTO ---
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Revisar consumos individuales detecta anomalías rápidamente y reduce desperdicio.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Ajustar calefacción según consumo real evita derroche.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Detectar fugas agua o calefacción a tiempo reduce pérdidas.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Programar horarios evita calentar espacios vacíos.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Comparar consumos entre unidades identifica irregularidades.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Educar usuarios sobre hábitos reduce consumo innecesario.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Registrar lecturas mensuales facilita control y planificación.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Optimizar distribución calor según consumo histórico ahorra energía.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Mantener válvulas y sensores operativos asegura eficiencia.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Ajustar termostatos según mediciones de calorímetro evita desperdicio.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Evaluar eficiencia sistemas antes de renovaciones previene gasto extra.',
    color: 'purple',
  },
  {
    title: 'Gestión y Reparto',
    type: 7,
    subtitle: 'Repartidores',
    desc: 'Usar datos históricos planifica mantenimiento y ahorro sostenido.',
    color: 'purple',
  },
];
